<script>
  // Moira logo — a ring of three arcs (Clotho, Lachesis, Atropos; also a pie).
  // See THEME.md §6.
  export let size = 28;
  export let dark = false; // wordmark on dark backgrounds
  export let wordmark = true;
</script>

<span class="inline-flex items-center gap-2.5 select-none">
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M 18.08 4.18 A 12 12 0 0 1 27.28 20.1" stroke="#059669" stroke-width="5" stroke-linecap="round" />
    <path d="M 25.19 23.71 A 12 12 0 0 1 6.81 23.71" stroke="#10B981" stroke-width="5" stroke-linecap="round" />
    <path d="M 4.72 20.1 A 12 12 0 0 1 13.92 4.18" stroke="#34D399" stroke-width="5" stroke-linecap="round" />
  </svg>
  {#if wordmark}
    <span class="font-semibold text-lg leading-none tracking-tight {dark ? 'text-white' : 'text-ink'}">
      Moira
      <span class="font-normal {dark ? 'text-slate-400' : 'text-ink-tertiary'}">Finance</span>
    </span>
  {/if}
</span>
